import { getEnv } from '~/env';

export const apolloLinkConfig = {
  developmentProgramLink: getEnv('REACT_APP_DEVELOPMENT_PROGRAM_API'),
  endpointServiceLink: getEnv('REACT_APP_ENDPOINT_SERVICE_API'),
};
